export interface DemographicValueModel {
  id: string;
  demographicId: string;
  name: string;
  index: number;
}
